import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import InfoIcon from '@material-ui/icons/Info'

import classNames from 'classnames'
import omit from 'lodash/omit'

import IconButton from '@eig-builder/core-ui/IconButton'

const styles = theme => ({
  tableMargin: {
    marginLeft: -theme.spacing(2)
  },
  disabled: {
    color: 'lightgray !important'
  }
})

const CustomIconButton = props => {
  const classes = classNames({
    [props.classes.tableMargin]: props.tableMargin,
    [props.customClasses]: props.customClasses
  })

  return (
    <IconButton
      classes={{ disabled: props.classes.disabled }}
      className={classes}
      {...omit(props, ['classes', 'icon', 'tableMargin', 'customClasses'])}
    >
      {props.icon}
    </IconButton>
  )
}

CustomIconButton.propTypes = {
  classes: PropTypes.object.isRequired,
  icon: PropTypes.element,
  tableMargin: PropTypes.bool,
  customClasses: PropTypes.string
}

CustomIconButton.defaultProps = {
  icon: <InfoIcon />,
  tableMargin: false
}

export default withStyles(styles)(CustomIconButton)
